import { render, staticRenderFns } from "./download-app-modal.vue?vue&type=template&id=62620efd"
import script from "./download-app-modal.vue?vue&type=script&lang=js"
export * from "./download-app-modal.vue?vue&type=script&lang=js"
import style0 from "./download-app-modal.vue?vue&type=style&index=0&id=62620efd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports